export default {
  title: 'Produits',
  buttons: {
    add_product: 'Ajouter un produit',
  },
  modals: {
    delete_product: {
      title: 'Êtes-vous sûr',
      description:
        'Tous les abonnements actuels liés à ce produit resteront actifs, mais aucun nouvel abonnement ne pourra être créé. Cette action est irréversible !',
    },
    delete_price: {
      title: 'Êtes-vous sûr',
      description:
        'Tous les abonnements actuels à ce tarif resteront actifs, mais aucun nouvel abonnement ne pourra être créé. Cette action est irréversible !',
    },
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement des données',
    failed_to_delete_product: 'Échec de la suppression du produit',
    product_got_deleted: 'Produit supprimé',
    failed_to_delete_price: 'Échec de la suppression du tarif',
    price_got_deleted: 'Tarif supprimé',
  },
};
